module.exports = __webpack_public_path__ + "static/paysans-3f991174b090cf2e72d4f5ad9781aedf.png";